/**
 * @generated SignedSource<<865dcb3c94a5735613636474e65b5c54>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditView_fragmentRef";
};
export type checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditView_fragmentRef$key = {
  readonly " $data"?: checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "checkboxSelect_issueFieldCheckboxSelectInlineEditFull_CheckboxSelectInlineEditViewWithIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraCheckboxesField"
};

(node as any).hash = "578907f93847166d177912bba783cc44";

export default node;
